import { createApp } from 'vue'
import App from './App.vue'
import { Button,Divider,Dialog } from 'vant'
import 'vant/lib/index.css';
import router from "./router"
import axios from './request/axios.js'
import 'lib-flexible'
// import "./utils/rem"
import  "amfe-flexible";


const app = createApp(App)
app.use(Button).use(Divider).use(Dialog).use(router).use(axios)

app.mount('#app')
